module.exports = __webpack_public_path__ + "static/img/homepage.4b8c814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage.png
// module id = HfyV
// module chunks = 1